<h1>Propostas de outros canais</h1>
<div *ngIf="propostasOutrosCanais.length > 0" class="list">
  <div class="list-item" *ngFor="let proposta of propostasOutrosCanais">
    <div mat-line class="mat-body-strong">{{proposta.canal | canaisPropostas}}</div>
    <div mat-line>
      Plano 
      <b>{{proposta.quantidadeParcelas}}x {{proposta.valorParcelas | currency:'BRL'}}</b>
      = <b>{{proposta.valorTotalPlano | currency:'BRL'}}</b>
    </div>
    <div mat-line>
      Entrada de <b>{{proposta.valorEntrada | currency:'BRL'}}</b> 
      para 
      <b>{{normalizeDate(proposta) | date:'dd/MM/yyyy'}}</b>
    </div>
  </div>
</div>

<div *ngIf="propostasOutrosCanais.length === 0">
  <p>Não foram encontradas propostas de outros canais</p>
</div>

<mat-dialog-actions align="end">
  <button 
    mat-raised-button 
    (click)="dialogRef.close()" 
    color="primary">
    Voltar
  </button>
</mat-dialog-actions>